import Vue from 'vue';
import Vuex from 'vuex';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import user from './modules/user';
import enedisCase from './modules/enedis-case';

Vue.use(Vuex);

const state = {
  connected: true,
  appNavBarTitle: 'PACMAN - ENEDIS',
  viewPortSize: '',
  globalToaster: {
    show: false,
    message: '',
    variant: '',
    duration: 0,
  },
  globalSpinnerShow: false,
  resizeWidth: 0,
  agencies: [],
  caseManagers: [],
};

const store = new Vuex.Store({
  modules: {
    user,
    enedisCase,
  },
  state,
  getters,
  actions,
  mutations,
});

// if (module.hot) {
//   module.hot.accept([
//     './getters',
//     './actions',
//     './mutations',
//   ], () => {
//     store.hotUpdate({
//       getters: require('./getters'),
//       actions: require('./actions'),
//       mutations: require('./mutations'),
//     });
//   });
// }

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js